export class ObligatoriskDokumentationIntroGetModel {
    brugerKursusraekkeId : string | null;
    brugerMaalbeskrivelseId : string | null;

    constructor(brugerKursusraekkeId : string | null, brugerMaalbeskrivelseId : string | null) {
        this.brugerKursusraekkeId = brugerKursusraekkeId;
        this.brugerMaalbeskrivelseId = brugerMaalbeskrivelseId;
    }
}
